export default {
  lang: {
    selectAll: 'اختر جميع الصفحات',
    selected: 'تم اختياره',
    term: 'المادة',
    deselect: 'إلغاء الاختيار',
  },
};
